import { render, staticRenderFns } from "./MenuLightbox.vue?vue&type=template&id=927d7972&scoped=true"
import script from "./MenuLightbox.vue?vue&type=script&lang=ts"
export * from "./MenuLightbox.vue?vue&type=script&lang=ts"
import style0 from "./MenuLightbox.vue?vue&type=style&index=0&id=927d7972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927d7972",
  null
  
)

export default component.exports